import React from 'react';
import { Button, Countdown, Section } from './Shared';
export const Closing = () => {
  return <>
      <Section bg="dark" data-id="element-10" data-mp="3t111zw6utgtq">
        <div className="max-w-4xl mx-auto" data-id="element-11" data-mp="3t09gxfavv1hp">
          <p className="text-center font-montserrat text-sm font-bold uppercase tracking-[0.18em] text-brand mb-4" data-id="element-12" data-mp="3f9mepd5wytgv">
            Una inversión práctica
          </p>
          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-center mb-12" data-id="element-13" data-mp="3j94ww16coqg0">
            ⚖️ Todo lo que podés construir con un sistema
          </h2>

          <div className="bg-[#353332] rounded-xl overflow-hidden border border-white/10 mb-12" data-id="element-14" data-mp="3abb4h1bpigy4">
            <div className="overflow-x-auto" data-id="element-15" data-mp="2wbjxhkjly0tm">
              <table className="w-full text-left font-montserrat" data-id="element-16" data-mp="2wcv03h1bh2j5">
                <thead data-id="element-17" data-mp="30cvgv8bw1ptd">
                  <tr className="bg-[#242322] text-base" data-id="element-18" data-mp="30e6hx0dy8jgs">
                    <th className="p-4 md:p-6 font-bold w-1/2" data-id="element-19" data-mp="uk6vb390y719">Acción práctica</th>
                    <th className="p-4 md:p-6 font-bold w-1/2 border-l border-white/10 text-brand" data-id="element-20" data-mp="yl8rfb7na2z0">Resultado que potenciás</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-white/10 text-gray-200" data-id="element-21" data-mp="3m2vzy5eco2n6">
                  <tr data-id="element-22" data-mp="3m2macix7vxi0">
                    <td className="p-4 md:p-6" data-id="element-23" data-mp="4meedlcls15d">Respondés WhatsApp con scripts claros</td>
                    <td className="p-4 md:p-6 font-bold text-brand bg-[#2B2A29] border-l border-white/10" data-id="element-24" data-mp="4o8oe4mc68uo">Más turnos confirmados cada mes</td>
                  </tr>
                  <tr data-id="element-25" data-mp="383we15i821up">
                    <td className="p-4 md:p-6" data-id="element-26" data-mp="3857fgyo72xin">Organizás tu contenido con intención</td>
                    <td className="p-4 md:p-6 font-bold text-brand bg-[#2B2A29] border-l border-white/10" data-id="element-27" data-mp="335usmdxbpqg2">Consultas constantes y una presencia profesional</td>
                  </tr>
                  <tr data-id="element-28" data-mp="3d1encx05ij38">
                    <td className="p-4 md:p-6" data-id="element-29" data-mp="3d4akij46d3qm">Aplicás un protocolo de re-agendamiento</td>
                    <td className="p-4 md:p-6 font-bold text-brand bg-[#2B2A29] border-l border-white/10" data-id="element-30" data-mp="x98mdis8h81y">Clientas que vuelven y recomiendan</td>
                  </tr>
                  <tr data-id="element-31" data-mp="ze58ftlxmhn4">
                    <td className="p-4 md:p-6" data-id="element-32" data-mp="zenchceu605l">Comunicás precios con seguridad</td>
                    <td className="p-4 md:p-6 font-bold text-brand bg-[#2B2A29] border-l border-white/10" data-id="element-33" data-mp="14d8bj8icqdsg">Ingresos alineados con tu calidad</td>
                  </tr>
                  <tr data-id="element-34" data-mp="1ec5za97ye3ae">
                    <td className="p-4 md:p-6" data-id="element-35" data-mp="1ebefdvnpxtzy">Planificás metas y agenda semanal</td>
                    <td className="p-4 md:p-6 font-bold text-brand bg-[#2B2A29] border-l border-white/10" data-id="element-36" data-mp="gp7a0jjlbxmj">Más claridad para decidir y crecer</td>
                  </tr>
                  <tr className="bg-payment text-white" data-id="element-37" data-mp="llfkhjmuf2nd">
                    <td className="p-4 md:p-6 font-bold" data-id="element-38" data-mp="qm3ca7iwbnin">Tu acceso inmediato al Megakit</td>
                    <td className="p-4 md:p-6 font-bold border-l border-white/30 text-xl" data-id="element-39" data-mp="vemxnqntrmy0">$17.990 una sola vez</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-[#2B2A29] p-8 rounded-xl border border-brand/40 mb-12 text-center" data-id="element-40" data-mp="2vprn22n4qy3">
            <h3 className="font-playfair text-2xl font-bold text-brand mb-4" data-id="element-41" data-mp="2g70mefyxxygw">
              Una decisión que acompaña tu crecimiento
            </h3>
            <p className="font-montserrat text-gray-200 mb-3" data-id="element-42" data-mp="276lyr9yi87a8">
              Cada herramienta del Megakit está pensada para ayudarte a comunicar tu valor, organizar tu agenda y disfrutar un negocio más claro.
            </p>
            <p className="font-montserrat text-xl font-bold text-base" data-id="element-43" data-mp="1x8y74sw73fwa">
              Una sola clienta extra puede potenciar la inversión. Todo lo demás es crecimiento.
            </p>
          </div>

          <div className="text-center font-montserrat text-lg md:text-xl space-y-5" data-id="element-44" data-mp="1ohfpedjlos13">
            <p className="font-bold text-brand" data-id="element-45" data-mp="1jhta7yk7p1pn">Tu talento ya está. El sistema te ayuda a convertirlo en un negocio organizado.</p>
            <p className="text-gray-300" data-id="element-46" data-mp="1egvml6gfnfgr">Aplicá los recursos a tu ritmo, con ejemplos claros y herramientas listas para usar desde hoy.</p>
            <p className="text-base font-bold" data-id="element-47" data-mp="19lgaaiy2prmg">No esperes al mes que viene. El próximo lunes tu negocio puede ser otro.</p>
          </div>
        </div>
      </Section>

      <Section bg="dark" className="border-t border-white/10 pt-16 pb-24" data-id="element-48" data-mp="3ejwsk60vnhqi">
        <div className="max-w-3xl mx-auto text-center" data-id="element-49" data-mp="2zuihmthnks90">
          <p className="font-montserrat text-sm font-bold uppercase tracking-[0.18em] text-brand mb-5" data-id="element-50" data-mp="34umzamuart0t">
            Resultados prácticos, desde hoy
          </p>
          <h2 className="font-playfair text-4xl md:text-6xl font-bold leading-tight mb-8 text-base" data-id="element-51" data-mp="2qtak4dmynvfz">
            Tu agenda puede estar llena.<br data-id="element-52" data-mp="2vrlucph647yq" />
            Tus clientas pueden volver solas.<br data-id="element-53" data-mp="2gxqxkhuae93w" />
            Tu negocio puede crecer con claridad.<br data-id="element-54" data-mp="2lvskjduu2skn" />
            <span className="text-brand" data-id="element-55" data-mp="2lv8ypm22bk1c">Desde hoy.</span>
          </h2>

          <p className="font-montserrat text-lg font-semibold text-base mb-5" data-id="element-56" data-mp="2lxlpmopst4qj">
            No esperes al mes que viene. El próximo lunes tu negocio puede ser otro.
          </p>

          <div className="mb-10" data-id="element-57" data-mp="k3mfi6oewtff">
            <p className="font-montserrat text-lg text-gray-300 mb-4" data-id="element-58" data-mp="24m6qztifd2pz">⏰ El precio de lanzamiento está disponible por tiempo limitado.</p>
            <div className="inline-block bg-[#353332] py-4 px-8 rounded-xl border border-white/10" data-id="element-59" data-mp="1zoofbvd0w9ea">
              <Countdown className="text-3xl md:text-4xl" data-id="element-60" data-mp="2ed1fl4j58eel" />
            </div>
          </div>

          <div className="flex flex-col gap-4 max-w-xl mx-auto mb-8" data-id="element-61" data-mp="29khz9zt2n563">
            <Button variant="brand" className="py-6 text-sm md:text-base" data-id="element-62" data-mp="2nco8f1xt4bw1">
              SÍ, QUIERO RESULTADOS ESTA SEMANA
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 font-montserrat text-xs text-gray-300" data-id="element-63" data-mp="2jdfbxpbdtzws">
            <span data-id="element-64" data-mp="2x8rgeofcb4qw">Pago 100% seguro</span>
            <span data-id="element-65" data-mp="2sbrcaj21wc2f">Acceso en 5 minutos</span>
            <span data-id="element-66" data-mp="2s9y3ax3ytfr9">Garantía 7 días</span>
            <span className="w-full md:w-auto" data-id="element-67" data-mp="12wktisd32zir">Mercado Pago · Tarjeta · Transferencia</span>
          </div>
        </div>
      </Section>

      <footer className="bg-[#242322] text-gray-400 py-12 px-6 font-montserrat text-sm border-t border-white/10" data-id="element-68" data-mp="xzb59g1fktwi">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-69" data-mp="2y23o7uw1gahc">
          <div className="text-center md:text-left max-w-md" data-id="element-70" data-mp="331gcmk2k5pm1">
            <h3 className="text-base font-bold mb-3 text-base" data-id="element-71" data-mp="36zw4b19l3m5s">💅 BÓVEDA DIGITAL™</h3>
            <p className="mb-4" data-id="element-72" data-mp="3c0ag8ueb3g93">
              El sistema N°1 para profesionales de estética independientes en Argentina. Tu talento merece un negocio organizado.
            </p>
            <p className="italic text-brand" data-id="element-73" data-mp="3lxybrmjqkrsb">"El próximo lunes tu negocio puede ser otro." 💅</p>
          </div>

          <div className="flex flex-col gap-2 text-center md:text-right" data-id="element-74" data-mp="3qoerxeexyrid">
            <a href="mailto:soportebovedadigital@gmail.com" className="hover:text-base transition-colors" data-id="element-75" data-mp="3uqidwwz8lehw">📧 soportebovedadigital@gmail.com</a>
            <a href="#" className="hover:text-base transition-colors" data-id="element-76" data-mp="3l9xir0yhjy1">📱 @boveda.digital.ok</a>
            <a href="#" className="hover:text-base transition-colors" data-id="element-77" data-mp="8kd4wi4es296">🌐 www.bovedadigital.online</a>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-12 pt-8 border-t border-white/10 text-center text-xs text-gray-500" data-id="element-78" data-mp="iojt7jh73456">
          <p data-id="element-79" data-mp="dqi9cwby30sn">© Bóveda Digital™ 2025 — Todos los derechos reservados. Prohibida la reproducción y redistribución sin autorización expresa.</p>
        </div>
      </footer>
    </>;
};